import { LockedPill } from '../LockedPill';

export interface PhotoSectionHeaderProps {
  id: string;
  /** Show the "Locked" pill: the viewer can see the photo but not change it. */
  locked: boolean;
}

/** The section title row, drawn like the other venue sections' headers. */
export function PhotoSectionHeader({ id, locked }: PhotoSectionHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 10,
        paddingBottom: 7,
        borderBottom: '1px solid var(--nb-border)',
      }}
    >
      <h3
        id={id}
        className="nb-display"
        style={{ margin: 0, fontSize: 13, letterSpacing: '.04em' }}
      >
        Booking photo
      </h3>
      <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>public-facing</span>
      <span style={{ flex: 1 }} />
      {locked && <LockedPill />}
    </div>
  );
}
